// DevHub CUSTOM — i18n "curator" namespace (the DevHub Assistant chat widget).
// ("curator" is retained as the internal namespace id / route only; all user-facing
// copy says "DevHub Assistant".) It is an advisory-only assistant: it answers questions
// about the DevHub and links to sources. See ./search.ts for the convention
// (createTranslationRef + self-registered German via `translations.de`).
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const curatorMessages = createTranslationRef({
  id: 'devhub.curator',
  messages: {
    launcherLabel: 'Ask the DevHub Assistant',
    header: 'DevHub Assistant',
    subheader: 'Your guide to the DevHub',
    closeLabel: 'Close',
    placeholder: 'Ask about docs, catalog, self-service…',
    send: 'Send',
    sendLabel: 'Send message',
    thinking: 'Thinking…',
    sources: 'Sources',
    error: 'Something went wrong reaching the DevHub Assistant. Please try again.',
    emptyTitle: 'Hi! I’m the DevHub Assistant 🤖',
    emptyState: 'Ask me anything about the DevHub — the catalog, guides, DevSecOps modules, APIs and tooling — and I’ll answer from the docs and point you to the source.',
    examplesLabel: 'Try asking',
    example1: 'What is the DevHub?',
    // Repointed off the Tech Radar when that surface became admin-only: a one-click
    // example chip must not send most viewers at a page they cannot open.
    example2: 'Where do I find the technology landscape?',
    example3: 'How do I add my service to the catalog?',
    disclaimer: 'The DevHub Assistant uses AI and can make mistakes — it’s advisory only, so always verify before acting.',
    you: 'You',
  },
  translations: {
    de: () => import('./de/curator'),
  },
});
